import { createReducer, on } from '@ngrx/store';
import { StatsActions } from './stats.actions';
import {StatGenerali, AndamentoMensile, StatsPie, StatsFlussoMensile} from '../../core/models/stats.model';

export interface StatsState {
  stats: StatGenerali | null;
  statsLoading: boolean;
  statsError: string | null;

  pie: StatsPie | null;
  flussoMensile: StatsFlussoMensile[];

  years: number[];
  yearsLoading: boolean;
  yearsError: string | null;
  selectedYear: number;

  andamentiMensili: AndamentoMensile[];
  andamentiLoading: boolean;
  andamentiError: string | null;
  andamentiTotalElements: number;
  andamentiTotalPages: number;
  andamentiPageIndex: number;
  andamentiPageSize: number;
}

export const initialState: StatsState = {
  stats: null,
  statsLoading: false,
  statsError: null,
  pie: null,
  flussoMensile: [],
  years: [],
  yearsLoading: false,
  yearsError: null,
  selectedYear: new Date().getFullYear(),

  andamentiMensili: [],
  andamentiLoading: false,
  andamentiError: null,
  andamentiTotalElements: 0,
  andamentiTotalPages: 0,
  andamentiPageIndex: 0,
  andamentiPageSize: 12,
};

export const statsReducer = createReducer(
  initialState,

  on(StatsActions.loadStats, (s) => ({ ...s, statsLoading: true, statsError: null })),
  on(StatsActions.loadStatsSuccess, (s, { stats }) => ({ ...s, statsLoading: false, stats })),
  on(StatsActions.loadStatsFailure, (s, { error }) => ({ ...s, statsLoading: false, statsError: error })),

  on(StatsActions.loadYears, (s) => ({ ...s, yearsLoading: true, yearsError: null })),
  on(StatsActions.loadYearsSuccess, (s, { years }) => ({ ...s, yearsLoading: false, years })),
  on(StatsActions.loadYearsFailure, (s, { error }) => ({ ...s, yearsLoading: false, yearsError: error })),

  on(StatsActions.selectYear, (s, { year }) => ({ ...s, selectedYear: year })),

  on(StatsActions.loadAndamentiMensili, (s) => ({ ...s, andamentiLoading: true, andamentiError: null })),
  on(StatsActions.loadAndamentiMensiliSuccess, (s, { items, totalElements, totalPages, pageIndex }) => ({
    ...s,
    andamentiLoading: false,
    andamentiMensili: items,
    andamentiTotalElements: totalElements,
    andamentiTotalPages: totalPages,
    andamentiPageIndex: pageIndex,
  })),
  on(StatsActions.loadAndamentiMensiliFailure, (s, { error }) => ({ ...s, andamentiLoading: false, andamentiError: error })),

  on(StatsActions.loadPieSuccess, (state, { data }) => ({
    ...state,
    pie: data,
  })),

  on(StatsActions.loadFlussoMensileSuccess, (state, { data }) => ({
    ...state,
    flussoMensile: data,
  })),

  );
